// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
// import { getAnalytics } from 'firebase/analytics';
// https://firebase.google.com/docs/web/setup#available-libraries

const stagingConfig = {
  apiKey: 'AIzaSyDUOf7_Ijq2LE-YXE6RKTlfkc5YDeX1PUY',
  authDomain: 'gyming-staging.firebaseapp.com',
  projectId: 'gyming-staging',
  storageBucket: 'gyming-staging.firebasestorage.app',
  messagingSenderId: '851712899276',
  appId: '1:851712899276:web:6d03956232439736f62a69',
  measurementId: 'G-8FNHJG5LBM',
};

const productionConfig = {
  apiKey: 'AIzaSyCcgC0iP8QK_yYnkRznQmCH-kpVgrDnIMg',
  authDomain: 'gyming-6694a.firebaseapp.com',
  projectId: 'gyming-6694a',
  storageBucket: 'gyming-6694a.appspot.com',
  messagingSenderId: '644880802075',
  appId: '1:644880802075:web:411727e3629789ff7f73be',
  measurementId: 'G-95KDBEEVR1',
};

// Native production builds also run without VITE_FIREBASE_* — do not treat
// "native + missing key" as staging (that sent prod TestFlight to gyming-staging).
const isStaging =
  import.meta.env.MODE === 'staging' ||
  import.meta.env.VITE_ENVIRONMENT === 'staging' ||
  (!import.meta.env.VITE_FIREBASE_API_KEY && import.meta.env.DEV);

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || (isStaging ? stagingConfig.apiKey : productionConfig.apiKey),
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || (isStaging ? stagingConfig.authDomain : productionConfig.authDomain),
  projectId:
    import.meta.env.VITE_FIREBASE_PROJECT_ID || (isStaging ? stagingConfig.projectId : productionConfig.projectId),
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||
    (isStaging ? stagingConfig.storageBucket : productionConfig.storageBucket),
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ||
    (isStaging ? stagingConfig.messagingSenderId : productionConfig.messagingSenderId),
  appId: import.meta.env.VITE_FIREBASE_APP_ID || (isStaging ? stagingConfig.appId : productionConfig.appId),
  measurementId:
    import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ||
    (isStaging ? stagingConfig.measurementId : productionConfig.measurementId),
};

export const firebaseApp = initializeApp(firebaseConfig);

export const firestore = getFirestore(firebaseApp);
